
function getPageProperties() {
    const custType =/** @type {any} */ (window).globalJsVariables?.customer_type
    const activeLoyalty= /** @type {any} */ (window).globalJsVariables?.active_loyalty
    const custId = /** @type {any} */ (window).customer?.memberId
    const pageMarket = /** @type {any} */ (window).market;

    
  return {
    custId,
    pageMarket,
    custType,
    activeLoyalty,
  }
}

// Standard CLICK properties the analytics pixel does not add itself.
function getStandardClickProperties() {
  return {
    PLATFORM: 'shopify',
    LOGGED_IN_STATE: /** @type {any} */ (window).customer ? 'LOGGED_IN' : 'LOGGED_OUT',
    TIME_STAMP_LOCAL: new Date().toLocaleString('en-US'),
    PAGE_QUERY_STRING: window.location.search,
  }
}

/**
 * Sends custom click event to Amplitude
 * @param {any} identifier - Event properties JSON
 */
export function amplitudeTrackClick(identifier) {
  try {
    const pageProperties = getPageProperties()
    const isProperties = identifier !== null && typeof identifier === 'object' && !Array.isArray(identifier)
    const eventData = isProperties ? { ...getStandardClickProperties(), ...identifier } : identifier

    Shopify.analytics.publish("CLICK", {
      eventData, ...pageProperties
    });
    
  } catch (error) {

  }
}

